import React from 'react';
import findout from '../assets/images/findout-1.png';
import elevate from '../assets/images/elvate.png';

const AfterTedx = () => {
  return (
    <div data-aos="fade-up" className="lg:px-16 p-4  rounded-lg ">
      <div className="flex flex-col lg:flex-row justify-between items-start gap-4 lg:gap-8">
        {/* Left Section */}
        <div className="lg:w-1/2 flex flex-col items-center p-5 justify-between gap-4 rounded-lg bg-gradient-to-b shadow-md transition-shadow duration-300 ">
          <div className="flex flex-col justify-start lg:min-h-[80px] text-center">
            <h1  style={{ fontFamily: "Helvetica" }} className="text-2xl text-blue-600 font-semibold mb-2">
              Elevate Your Influence
            </h1>
            <h1  style={{ fontFamily: "Helvetica" }} className="text-lg text-gray-800 font-semibold">
              The Foundation Pillars of a Powerful Executive Presence
            </h1>
          </div>
          <div  className="w-full h-auto flex justify-center items-center p-5">
            <img
              src={elevate}
              alt="elevate"
              className="w-full h-auto lg:h-[350px] object-contain rounded-lg "
            />
          </div>
        </div>

        {/* Right Section */}
        <div data-aos="fade-up" className="lg:w-1/2 flex flex-col p-5 items-center justify-between gap-4 rounded-lg bg-gradient-to-b  shadow-md transition-shadow duration-300 ">
          <h1  style={{ fontFamily: "Helvetica" }} className="text-2xl text-center text-blue-600 font-semibold lg:text-center  lg:min-h-[80px]">
            Your Executive Presence is evaluated based on seven key elements
          </h1>
          <div className="w-full h-auto flex justify-center items-center p-5">
            <img
              src={findout}
              alt="find_out"
              className="w-full h-auto lg:h-[350px] max-h-[370px] object-contain rounded-lg "
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AfterTedx;
